var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _g2, _path24, _g3, _path25, _g4, _path26, _g5, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgCalendarHeaderIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 16.218V1.277l.043-.166v14.941c0 .155-.023.31-.075.473l-.031.097c.045-.14.063-.288.063-.404Z",
    fill: "#B9CBD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.424.73c.639-.306 1.185-.061 1.187.547v14.941c.002.608-.49 1.348-1.128 1.653l-7.287 3.48c-.64.306-1.185.06-1.187-.547V5.862c-.002-.608.489-1.348 1.128-1.653L9.424.729Z",
    fill: "url(#calendar-header-icon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.984 3.951 9.271.472c.747-.357 1.38-.07 1.382.64l-.043.165C10.608.67 10.063.424 9.423.73L2.137 4.21c-.64.305-1.13 1.045-1.128 1.652v14.942c.002.608.548.853 1.187.548l7.287-3.48c.135-.064.264-.148.384-.246l-.086.07c-.141.114-.292.212-.45.287l-7.287 3.48c-.746.357-1.379.07-1.382-.64V5.884c-.002-.71.576-1.575 1.322-1.932Z",
    fill: "#B9CBD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.571.075c-.246-.118-.586-.1-.962.078l-7.287 3.48C.575 3.99-.002 4.854 0 5.564v14.942c.001.352.177.6.42.717l.662.318c-.242-.116-.418-.364-.42-.717V5.882c-.002-.71.576-1.574 1.322-1.93L9.271.471c.376-.18.716-.196.962-.078L9.571.075Z",
    fill: "url(#calendar-header-icon_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m1.89 19.815 8.257-3.944V1.111L1.89 5.054v14.76Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m.509 8.92-.455-.217V7.356l.455.217V8.92ZM.509 10.402l-.455-.218V8.837l.455.217v1.348Z",
    fill: "#2E2E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m5.423 18.998 2.138-1.021a.31.31 0 0 0 .163-.256c0-.1-.073-.145-.163-.102L5.423 18.64a.31.31 0 0 0-.162.257c0 .099.072.144.162.101Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.933 10.758c2.202 3.754 2.824 6.606 5.65 5.868 1.195-.313 2.458-.698 3.345-1.378.646-.495 1.028-1.087 1.966-1.136 2.04-.105-.178 1.493-.794 2-.828.685-2.123 1.48-3.153 1.968-2.557 1.212-5.352 1.077-8.81-2.565-.633-.666-2.482 2.513-2.36 1.518.078-.647 2.23-5.61 2.853-5.606",
    fill: "url(#calendar-header-icon_svg__c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73 34.166s-.439.046-.759.253c-.32.206-.64.413-.35.679.289.265.389.704.367 1.095-.023.39.407.782.932 1.128.427.28.681.017.757-.14.074-.155-.09-.778-.212-1.23-.121-.45-.013-1.338-.013-1.338l-.722-.447Z",
    fill: "url(#calendar-header-icon_svg__d)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m4.576 39.269-.344.575a.981.981 0 0 0-.136.625c.042.348.12.873.232 1.105.173.361 1.011.488 1.341.398.329-.09.266-.784.164-1.519-.048-.338-.28-1.112-.28-1.112l-.977-.072Z",
    fill: "url(#calendar-header-icon_svg__e)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.566 39.411c-.395-2.415.357-6.722 1.208-11.193l2.868-.047c-.914 4.192-1.947 8.06-3.178 11.383 0 0-.56.269-.898-.143Z",
    fill: "url(#calendar-header-icon_svg__f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 34.5c-.072-.075-.092-.186-.022-.262 3.314-3.652 4.401-5.296 6.61-7.985l-.2 3.309c-1.796 2.477-2.425 3.115-5.609 5.136a.5.5 0 0 1-.526.012 1.518 1.518 0 0 1-.253-.21Z",
    fill: "url(#calendar-header-icon_svg__g)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.756 33.829c.511.184 1.8.143 2.046 0 13.017-7.595-1.43-13.45-1.43-13.45l-4.528 1.043s-.037 2.364.3 3.447c.101.32 12.072 1.707 3.612 8.96Z",
    fill: "#2E2E2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.092 37.99c5.523-9.739 2-16.529 2-16.529L2.36 23.278s3.843 1.09 1.78 14.797c.385.128 1.47.062 1.953-.085Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 15.614c-.157-3.298-.694-6.336-2.269-6.833-.587-.184-4.883 1.261-5.005 1.354l-.157.056c-1.744.603-1.664 3.032-1.523 4.45-.467 3.775-.038 8.51.353 8.893.678.665.935.74 2.97.635 1.191-.061 3.687.005 5.279-.736 1.592-.743.509-4.524.352-7.819Z",
    fill: "url(#calendar-header-icon_svg__h)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m5.78 7.642-.483 1.985-.468.152c-.214.07-.267.3-.097.428.719.542 2.362 1.626 3.342 1.053.658-.384.51-1.295-.102-2.334l-.876-.161.05-1.123H5.78Z",
    fill: "url(#calendar-header-icon_svg__i)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.996s-.014 1.418-.138 2.086c-.125.67-.279 1.322-1.15 1.304-.87-.017-1.742-.478-2.366-1.64-.625-1.161-.34-2.077.253-2.498.592-.42 3.23-.292 3.4.748Z",
    fill: "url(#calendar-header-icon_svg__j)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.975 7.506s-.166.188-.253.298c-.085.11-.285-.255-.715-.878-.431-.622-.54-1.71.113-1.947.652-.237.518-.34.866-.67.347-.33.717-.394 1.878-.229 1.163.166 1.46.02 1.696-.19 1.172-1.047 2.211 1.458.986 1.183-.433-.098-.093.664-.555.946-.461.283-2.008.267-2.666.098-.658-.168-.569.215-.556.73.013.518-.122 1.268.5 1.64.62.373 2.158-.073 2.158-.073s.382 1.994-.492 2.344c-1.845.736-2.346-.927-2.682-2.029-.2-.654-.278-1.223-.278-1.223Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.469 7.48s-.03-.573-.492-.576c-.464-.002-.332.66.185.954.516.294.307-.378.307-.378Z",
    fill: "url(#calendar-header-icon_svg__k)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.478 13.197c.806 2.029 1.013 3.784 1.677 4.008 1.17.394 2.525-1.543 3.667-1.874 1.02-.295 2.285-.246 2.352-.12.107.197-.676.31-.8.556-.22.439-.087.949-1.227 1.092-1.157.146-3.444 3.036-4.598 2.807-2.12-.42-3.841-5.482-3.057-6.244.509-.495 1.427-.59 1.937-.294",
    fill: "url(#calendar-header-icon_svg__l)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.338 7.672c.113.429.571.71 1.023.628.451-.082.725-.495.612-.924-.113-.428-.57-.71-1.022-.628-.452.082-.726.495-.613.924Z",
    fill: "#FF0082"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.412 4.143S5.952 4.571 6 7.235c-.379-.068-.522-2.612 1.539-3.184.296-.082.873.021.873.092ZM6.301 8.207s.8 1.675 2.291 1.278c.213.088 0 .176 0 .176s-1.332.53-2.504-1.366",
    fill: "#FF0082"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.249 9.618c.022.152.237.256.479.232.242-.024.42-.168.397-.32-.022-.153-.237-.257-.479-.233-.241.025-.42.168-.397.32Z",
    fill: "#FF0082"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.61 22.36 12.9 28.045v-.023l11.71-5.683v.023Z",
    fill: "#2E2E2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m12.93 27.3-.036.018v-.023l.035-.017v.023ZM24.499 21.685l-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.033V21.9l.07-.033v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.022Zm-.138.068-.07.034v-.023l.07-.033v.022Zm-.14.067-.07.034v-.022l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.068.034v-.023l.07-.034-.001.023Zm-.138.067-.07.035v-.023l.07-.034v.023Zm-.14.068-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.035v-.023l.07-.034v.022Zm-.14.068-.069.034v-.022l.07-.035v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.139.068-.07.034V24.2l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.033v.022Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.023Zm-.138.067-.07.035v-.023l.07-.034v.023Zm-.14.069-.07.033v-.022l.07-.035v.024Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.023l.07-.033v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.022Zm-.138.069-.07.034v-.023l.07-.035v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.023l.07-.033v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034V26.5l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.035v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.035v.024Zm-.139.067-.07.034v-.023l.07-.034v.023ZM24.604 21.635l-.036.017v-.023l.035-.017v.023Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m24.598 20.908-11.71 5.683v-.023l11.71-5.683v.023Z",
    fill: "#2E2E2E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m12.918 25.848-.035.016v-.022l.035-.017v.023ZM24.488 20.232l-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.023Zm-.139.068-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.023l.07-.033v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.139.069-.07.033v-.023l.07-.033v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.035v-.023l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.139.069-.07.033v-.023l.07-.033v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.033v-.023l.07-.034v.024Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034V24.1l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.023l.07-.033v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.035v-.023l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.022l.07-.035v.023ZM24.592 20.181l-.035.017v-.022l.035-.017v.023Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m24.585 19.454-11.71 5.683v-.023l11.71-5.683v.023Z",
    fill: "#2E2E2E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m12.905 24.394-.034.017v-.023l.034-.017v.023ZM24.475 18.778l-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.023Zm-.138.068-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.035v-.024l.07-.033v.022Zm-.14.068-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.139.068-.07.033v-.023l.07-.034v.024Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.022l.07-.034v.022Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034V21.7l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034V21.9l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.069.035v-.023l.07-.035v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.023l.07-.033v.023Zm-.138.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.033v-.023l.07-.034v.024Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.138.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.033v.022Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.035v-.023l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.022l.07-.035v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034V24l.07-.034v.022Zm-.139.069-.07.034v-.023l.07-.034v.022Zm-.14.067-.069.033v-.022l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.023l.07-.033v.023Zm-.14.067-.069.034v-.023l.07-.034v.023ZM24.58 18.728l-.036.016v-.022l.035-.017v.023Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m24.572 18.001-11.71 5.683v-.022l11.71-5.684v.023Z",
    fill: "#2E2E2E"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m12.893 22.94-.035.016v-.022l.035-.017v.023ZM24.462 17.324l-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.034v-.022l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.138.067-.07.035v-.024l.07-.033v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.033v.022ZM23.07 18l-.07.034v-.022l.07-.034V18Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.023l.07-.033v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.035v-.023l.07-.034v.022Zm-.14.069-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.033v-.023l.07-.033v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.068-.07.033v-.022l.07-.034v.023Zm-.14.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034V19.5l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.068.033v-.022l.069-.035v.024Zm-.138.067-.07.034v-.022l.07-.035v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.07.035v-.023l.07-.034v.022Zm-.139.068-.07.034v-.022l.07-.035v.023Zm-.14.068-.07.034v-.022l.07-.034v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.022l.07-.035v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.033v-.022l.07-.034v.023Zm-.138.067-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.07.034v-.023l.07-.033v.022Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034V21.8l.07-.033v.022Zm-.139.067-.07.035v-.023l.07-.034v.023Zm-.14.069-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.034v.023Zm-.138.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.07.034v-.023l.07-.034v.023Zm-.139.067-.07.034v-.022l.07-.034v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.033v-.022l.07-.034v.023Zm-.139.067-.07.034v-.023l.07-.033v.022Zm-.14.068-.069.034v-.023l.07-.034v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.067-.069.034v-.023l.07-.033v.023Zm-.139.068-.07.034v-.023l.07-.034v.023Zm-.14.068-.069.034v-.023l.07-.034v.023ZM24.567 17.274l-.035.016v-.022l.034-.017v.023Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.56 16.548 12.85 22.23v-.023l11.71-5.683v.024Z",
    fill: "#2E2E2E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M11.3 27.436s.433-3.564 1.836-4.244c1.403-.681.852 1.807 2.107 1.198.995-.483.914-4.198 2.22-4.831 1.305-.634 1.199 2.362 2.156 1.898.957-.464.395-1.58 1.73-2.227 1.333-.647 1.66 2.523 1.66 2.523L11.3 27.436Z",
    fill: "url(#calendar-header-icon_svg__m)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m13.092 26.577-.023.012-.029-3.364.023-.012.029 3.364Z",
    fill: "url(#calendar-header-icon_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.182 26.552c0 .05-.045.11-.101.138-.057.027-.103.01-.104-.038 0-.049.046-.11.102-.138.057-.027.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.154 23.17c0 .048-.046.11-.102.137-.056.027-.102.01-.103-.038 0-.05.045-.11.102-.138.056-.027.102-.01.103.039Z",
    fill: "url(#calendar-header-icon_svg__p)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m17.556 24.413-.023.01-.042-4.853.023-.011.042 4.854Z",
    fill: "url(#calendar-header-icon_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.646 24.387c0 .049-.045.11-.101.138-.057.027-.103.01-.104-.039 0-.048.046-.11.102-.137.056-.028.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.605 19.514c0 .049-.045.11-.102.138-.056.027-.102.01-.103-.038 0-.05.046-.11.102-.138.057-.028.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__s)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m21.394 22.548-.023.012-.028-3.279.023-.011.028 3.278Z",
    fill: "url(#calendar-header-icon_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M21.485 22.524c0 .048-.045.11-.102.138-.056.027-.102.01-.103-.039 0-.048.045-.11.102-.138.056-.027.102-.01.103.039Z",
    fill: "url(#calendar-header-icon_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M21.457 19.226c0 .05-.046.11-.102.138-.056.027-.103.01-.103-.038 0-.049.045-.11.102-.138.056-.027.102-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__v)"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M12.9 28.022s.452-1.421 1.855-2.102c1.403-.681.801-4.225 2.056-4.835.995-.483.96 1.258 2.266.624 1.305-.633 1.197 2.088 2.154 1.623.957-.464.39-2.293 1.723-2.94 1.334-.648 1.656 1.947 1.656 1.947L12.9 28.022Z",
    fill: "url(#calendar-header-icon_svg__w)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m14.693 27.163-.024.011-.01-1.22.023-.011.01 1.22Z",
    fill: "url(#calendar-header-icon_svg__x)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.784 27.138c0 .048-.045.11-.102.138-.056.027-.103.01-.103-.039 0-.048.045-.11.102-.137.056-.028.102-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__y)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.773 25.898c0 .049-.045.11-.102.138-.056.027-.103.01-.103-.038 0-.05.046-.11.102-.138.056-.028.102-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__z)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m19.155 24.996-.023.012-.029-3.289.024-.01.028 3.287Z",
    fill: "url(#calendar-header-icon_svg__A)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M19.247 24.971c0 .049-.045.11-.102.138-.056.027-.103.01-.103-.039 0-.048.045-.11.102-.137.056-.028.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__B)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M19.218 21.664c0 .049-.045.11-.101.138-.057.027-.103.01-.103-.038 0-.05.045-.11.101-.138.056-.028.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__C)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m22.993 23.134-.023.011-.023-2.701.024-.012.022 2.702Z",
    fill: "url(#calendar-header-icon_svg__D)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.085 23.109c.001.048-.045.11-.101.137-.056.028-.103.01-.103-.038 0-.049.045-.11.102-.138.056-.027.102-.01.102.039Z",
    fill: "url(#calendar-header-icon_svg__E)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.062 20.388c0 .049-.045.11-.102.138-.056.027-.103.01-.103-.039 0-.048.046-.11.102-.137.056-.027.103-.01.103.038Z",
    fill: "url(#calendar-header-icon_svg__F)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.804 16.576c.062-.032 8.1-3.875 8.19-3.872l.021.002c.041.008.06.022.32.147-.058-.028-.13-.012-.188.015-6.753 3.225-8.104 3.842-8.201 3.952-.159.178-.06 5.645-.11 8.177 0 .055.023.112.08.14-.296-.143-.356-.145-.356-.274l-.008-7.916c0-.136.112-.299.252-.37Z",
    fill: "#BDCCD4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.411 12.993c0-.138-.119-.194-.264-.124l-8.054 3.836c-.145.07-.257.238-.257.377v7.915c0 .138.121.194.267.124l8.053-3.836c.146-.07.263-.238.263-.377l-.008-7.915Z",
    fill: "#BDCCD4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.218 15.445c.186-.09.337-.017.338.16 0 .176-.15.391-.336.48l-1.825.872c-.186.089-.338.017-.338-.16-.001-.176.15-.392.336-.48l1.825-.872ZM11.492 20.224c.058-.028.105-.005.105.05 0 .054-.046.121-.104.149l-.673.321c-.058.028-.105.006-.105-.05 0-.054.046-.121.104-.149l.673-.321ZM10.516 20.691c.058-.027.105-.005.105.05s-.047.121-.104.149l-.117.055c-.057.028-.104.006-.104-.05 0-.054.046-.121.104-.149l.116-.055ZM12.025 19.97c.058-.028.104-.006.104.049s-.046.122-.104.15l-.242.115c-.057.027-.104.005-.104-.05 0-.054.046-.121.104-.149l.242-.116ZM13.852 18.018c.208-.1.377-.02.378.177 0 .198-.168.439-.376.538l-5.176 2.472c-.208.1-.377.02-.377-.178 0-.198.167-.439.375-.538l5.176-2.471Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.856 18.518c.109-.052.198-.01.198.093s-.088.23-.196.281l-1.975.943c-.109.052-.197.01-.197-.093 0-.104.087-.23.196-.281l1.974-.943Z",
    fill: "#5ABAB8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 16.905c.208-.1.377-.02.377.178.001.198-.167.439-.375.538L8.66 20.093c-.208.1-.377.019-.378-.178 0-.198.168-.439.375-.538l5.177-2.472Zm.026.468c.071-.034.128-.116.128-.183 0-.067-.058-.094-.129-.06l-.873.417c-.071.034-.128.116-.128.183 0 .067.058.094.128.06l.874-.417Z",
    fill: "#FF0082"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.147 17.763c.108-.052.197-.01.197.093 0 .104-.087.23-.196.281l-1.269.606c-.109.052-.197.01-.197-.093s.087-.23.196-.281l1.269-.606Z",
    fill: "#5ABAB8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.859 17.13c.071-.034.128-.007.129.06 0 .067-.057.149-.128.183l-.873.417c-.071.034-.128.007-.129-.06 0-.068.057-.15.128-.183l.873-.417ZM13.845 15.819c.208-.1.377-.02.378.178 0 .197-.167.438-.376.538l-5.176 2.471c-.208.1-.377.02-.377-.178 0-.198.167-.438.375-.537l5.176-2.472Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.896 17.95c.071-.033.128-.006.129.061 0 .067-.057.149-.128.183l-.873.417c-.07.034-.128.007-.128-.06 0-.068.056-.15.127-.183l.873-.417Z",
    fill: "#FF0082"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.904 20.437c-.014-.007-.292-.142-.308-.144a.091.091 0 0 0-.024 0l-.014.003c-.024.006-.436.206-.447.213a.21.21 0 0 0-.09.125c-.002.014-.003.403.002.424a.061.061 0 0 0 .03.042l.29.139c-.024-.011-.033-.037-.034-.059-.001-.38-.006-.392.008-.43a.216.216 0 0 1 .102-.114c.017-.008.408-.196.427-.201a.083.083 0 0 1 .058.002Z",
    fill: "#009983"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.824 20.443c.062-.03.112-.006.113.053l.001.384c0 .058-.05.13-.112.16l-.404.192c-.062.03-.112.006-.112-.052l-.001-.384c0-.06.05-.13.11-.16l.405-.193Z",
    fill: "#00AF9B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.104 20.82c-.014-.006-.292-.142-.307-.144a.084.084 0 0 0-.025 0l-.014.003c-.024.006-.436.206-.447.213a.21.21 0 0 0-.088.12l-.001.005c-.003.014-.003.403 0 .424a.06.06 0 0 0 .032.042l.289.139c-.023-.011-.033-.038-.033-.06-.002-.379-.006-.392.007-.429a.214.214 0 0 1 .103-.114c.016-.008.408-.196.426-.202a.086.086 0 0 1 .058.003Z",
    fill: "url(#calendar-header-icon_svg__G)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.024 20.826c.062-.03.112-.006.113.053v.384c.001.058-.049.13-.11.16l-.404.192c-.062.03-.112.006-.113-.053l-.001-.384c0-.059.05-.13.111-.16l.404-.192Z",
    fill: "#FF0082"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.306 21.202c-.014-.006-.292-.142-.307-.144a.091.091 0 0 0-.025 0l-.014.003a12.55 12.55 0 0 0-.447.213.21.21 0 0 0-.09.126c-.002.014-.002.402.002.423a.06.06 0 0 0 .03.042l.29.139c-.024-.011-.033-.037-.033-.06-.002-.379-.007-.391.007-.429a.216.216 0 0 1 .102-.114c.017-.008.409-.196.427-.202a.089.089 0 0 1 .058.003Z",
    fill: "#62007A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.225 21.208c.063-.03.113-.006.113.053l.001.384c0 .058-.05.13-.112.16l-.403.192c-.062.03-.112.006-.113-.052l-.001-.384c0-.06.05-.131.111-.16l.404-.193Z",
    fill: "#2E2E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.505 21.585c-.013-.006-.291-.142-.307-.144a.084.084 0 0 0-.024 0l-.015.003c-.024.006-.435.206-.447.213a.21.21 0 0 0-.087.12l-.002.006c-.003.014-.003.402.001.423a.06.06 0 0 0 .03.042l.29.139c-.023-.01-.033-.037-.033-.06-.001-.379-.006-.391.007-.429a.214.214 0 0 1 .103-.114c.016-.008.408-.196.426-.201a.088.088 0 0 1 .058.002Z",
    fill: "#FF0082"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M10.426 21.591c.062-.03.112-.006.112.053l.001.384c0 .059-.05.13-.111.16l-.404.192c-.062.03-.112.006-.112-.052l-.002-.384c0-.059.05-.13.111-.16l.405-.193Z",
    fill: "#FF0082"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.224 10.88s-.683-.335-.905-.433c-.127-.057-.262-.063-.343.003-.044.037-.236.216-.236.216.082-.065.214-.058.34-.002.223.099.906.433.906.433.348.213.378.457.374.989-.011 1.413 0 3.432-.014 4.796a.173.173 0 0 1-.038.127l.164-.161c.053-.052.112-.103.113-.183 0-.46.002-3.383.013-4.796.004-.533-.026-.776-.374-.989Z",
    fill: "url(#calendar-header-icon_svg__H)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M19.47 9.563s-.692-.354-.943-.45a.442.442 0 0 0-.387.057c-.033.027-.122.094-.198.187.073-.078.206-.08.334-.032.25.095.955.455.955.455.204.125.337.276.356.53-.009 1.97-.028 5.66-.034 7.583a.23.23 0 0 1-.122.202c.096-.047.202-.182.251-.224.057-.05.11-.112.11-.196.005-1.924.024-5.612.033-7.582-.019-.254-.152-.405-.356-.53Z",
    fill: "url(#calendar-header-icon_svg__I)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M22.146 8.86c0-.188-.168-.29-.316-.367-.225-.118-.68-.306-.934-.42a.352.352 0 0 0-.337.019c-.048.027-.268.166-.28.24.071-.13.218-.142.375-.071.256.114.938.45.938.45.142.085.316.178.316.366 0 2.216.002 9.711 0 9.976-.001.107-.06.181-.149.206.107-.012.251-.19.292-.24.04-.05.094-.1.095-.183.002-.265 0-7.76 0-9.976Z",
    fill: "url(#calendar-header-icon_svg__J)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.985 11.098c.349.212.378.456.374.988-.011 1.413 0 3.432-.013 4.797.014.176-.204.263-.384.166l-.308-.147c-.842-.407-.977-.312-1.004-1.038 0-.378.006-4.814.012-5.016.006-.238.22-.271.418-.183.222.098.905.433.905.433Zm1.29-1.773c-.187-.07-.387-.032-.387.193l-.003.617s-.009 5.133-.009 6.816c0 .52.182.62.378.72.069.034.57.27.895.424.203.097.403-.023.403-.202.006-1.924.025-5.613.034-7.582-.019-.255-.152-.406-.356-.531 0 0-.704-.36-.954-.455Zm2.378-1.064c-.195-.087-.405-.051-.414.184-.006.169-.002.618-.002.618s-.01 6.74-.01 8.985c0 .488.076.597.374.742.148.073.695.334.937.443.2.089.366.001.368-.18.002-.265 0-7.76 0-9.976 0-.188-.174-.28-.316-.367 0 0-.682-.335-.937-.449Z",
    fill: "url(#calendar-header-icon_svg__K)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.537 5.657s-.743-.142-.754-.66c-.005-.27.098-.411.394-.53.206-.082.317-.44.917-.335.495.086.648.34.587.754-.085.572-.79.73-.79.73l-.354.04Z",
    fill: "url(#calendar-header-icon_svg__L)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.733 5.207c.016.039.046.072.087.097.11.066.238.28.276.69.064.698 1.065.314 1.482 2.018.023.095.788-.348.57-.818-.38-.822.04-.928-.237-1.312-.233-.323-.734-.128-.873-.893-.093-.512-.617-.963-1.158-.763-.447.165-.234.775-.147.98Z",
    fill: "url(#calendar-header-icon_svg__M)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.823 4.79s-.604-.251-.888.18c-.095.182-.107.452.398.622l-.22-.484s.01-.195.71-.319Z",
    fill: "url(#calendar-header-icon_svg__N)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.324 6.766s.07-.53.363-.677c.233-.117.427-.359.374-.448-.051-.087-.397-.225-.53-.191s-.237.32-.281.494c-.044.175-.43.612-.43.612s.414.282.504.21Z",
    fill: "url(#calendar-header-icon_svg__O)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m16.709 5.974-.351-.263c-.021-.015-.021-.041-.002-.057l.641-.527a.055.055 0 0 1 .066 0l.334.261c.02.016.02.041.001.057l-.624.528a.055.055 0 0 1-.066 0Z",
    fill: "#2E2E2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 6.36c.08-.097.233.04.46.28 0 0-.067.613.055.772.063-.047.116-.13.136-.27.026-.193.052-.317.274-.67.225-.358.578-.474.578-.474s-.295.754-.373 1.042c-.167.621-.207.96-.403 1.08-.126.078-.401.22-.726-.135-.366-.4-.304-1.253 0-1.625Z",
    fill: "#62007A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.035 13.563s.01.037.136.11c.053.03.12.041.214.108.184.13-.261.367-.388.633-.078.161-.362.187-.465.145-.104-.04-.014-.192.156-.35.17-.158.1-.371.1-.371l.247-.274ZM16.985 14.018s.012.09.052.153c.035.051.123.148.13.186.018.107-.324.28-.512.475-.15.155-.787.187-.501-.092.278-.27.449-.441.456-.618.008-.2.375-.104.375-.104Z",
    fill: "#2E2E2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 9.085s-2.958.975-2.88 1.66c.08.683.989 2.47 1.542 3.095.172-.022.286-.162.255-.27-.205-.743-.504-2.42-.732-2.564 1.61-.423 3.199-1.205 3.199-1.205l-.865-.626-.519-.09Z",
    fill: "#00AF9B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.915 9.19c-1.785.925-3.355 1.995-3.286 2.408.056.33.125.835.985 2.564.043.103.349.115.391-.04-.264-1.078.04-1.934-.331-2.348 1.046-.542 3.027-.56 2.692-2.246-.13-.656-.451-.339-.451-.339Z",
    fill: "#00AF9B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.768 5.819s-.412.108-.615.431c-.2.32-.357.96-.404 1.164-.008.038-.056.57-.014.586.082.176 0 1.945.267 1.928.072-1.514.766-4.11.766-4.11Z",
    fill: "#2E2E2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.657 8.174s.654.995.723 1.417c.07.422-1.757.027-1.757.027l-.583-.374.152-1.289 1.465.219Z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.928 8.262v.001c.014.087-.05.169-.153.188-.54.1-1.218-.323-1.582-.496-.135-.063-.236-.339-.225-.477.047-.627.223-.697.35-1.08.273-.816.886-.637 1-.587l.027.015c.05.033.262.168.489.3.254.146.242.727.17 1.018a.14.14 0 0 1-.018.037c-.084.135-.125.647-.058 1.08Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.734 5.416c0 .006.024.477.06.619.217.055.508-.106.538-.158.03-.053-.234-.663-.243-.725-.009-.063-.355.264-.355.264Z",
    fill: "url(#calendar-header-icon_svg__P)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.071 5.01s.04.102.128.295c.148.322.357.426.431.456.074.03.289.023.5-.27.212-.292-.07-.432-.078-.45-.002-.007-.039-.067-.083-.142-.102-.17-.358-.235-.555-.137-.157.078-.269.16-.343.249Z",
    fill: "url(#calendar-header-icon_svg__Q)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18.345 5.827s.15.153-.009.367c-.158.214-.097 3.555-.092 4.33.005.774 1.076.209 1.171.082.365-.487-.083-1.136-.12-1.489-.056-.542-.347-1.921-.302-2.198.046-.277.445-.65-.648-1.092Z",
    fill: "#2E2E2E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m18.627 9.819-.483-1.437-1.56.323.524 1.424 1.52-.31Z",
    fill: "#DBDEFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.924 9.056s-.464.243-.77.208c-.169-.02-.43-.016-.5.05s-.037.373.071.428c.108.054.404-.06.573-.143.17-.082.758-.13.758-.13s-.019-.405-.132-.413Z",
    fill: "url(#calendar-header-icon_svg__R)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.912 6.193s.505.25.684 1.819c.118 1.025-1.744 1.516-1.744 1.516s-.136-.137-.131-.412c0 0 1.028-.875 1.055-1.046.044-.278-.03-.84-.03-.84l-.115-.551s.018-.48.28-.486Z",
    fill: "#62007A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__a",
    x1: 5.81,
    y1: 21.482,
    x2: 5.81,
    y2: 0.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__b",
    x1: 5.117,
    y1: 19.463,
    x2: 5.117,
    y2: -1.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__c",
    x1: 14.632,
    y1: 11.919,
    x2: 11.623,
    y2: 19.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__d",
    x1: 8.434,
    y1: 34.881,
    x2: 10.824,
    y2: 37.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__e",
    x1: 4.06,
    y1: 40.568,
    x2: 5.989,
    y2: 40.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__f",
    x1: -1.791,
    y1: 30.515,
    x2: 9.756,
    y2: 37.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__g",
    x1: 19.575,
    y1: 30.121,
    x2: 12.648,
    y2: 30.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__h",
    x1: 1.835,
    y1: 16.487,
    x2: 11.498,
    y2: 16.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__i",
    x1: 5.685,
    y1: 14.323,
    x2: 6.552,
    y2: 8.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__j",
    x1: 13.281,
    y1: 6.248,
    x2: 2.418,
    y2: 8.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__k",
    x1: 8.365,
    y1: 6.318,
    x2: 5.381,
    y2: 8.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__l",
    x1: 10.803,
    y1: 13.28,
    x2: 3.819,
    y2: 18.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__m",
    x1: 23.294,
    y1: 19.173,
    x2: 11.22,
    y2: 19.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__n",
    x1: 13.047,
    y1: 24.9,
    x2: 13.071,
    y2: 24.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__o",
    x1: 12.97,
    y1: 26.602,
    x2: 13.175,
    y2: 26.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__p",
    x1: 12.942,
    y1: 23.219,
    x2: 13.147,
    y2: 23.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__q",
    x1: 17.505,
    y1: 21.991,
    x2: 17.528,
    y2: 21.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__r",
    x1: 17.434,
    y1: 24.436,
    x2: 17.639,
    y2: 24.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__s",
    x1: 17.393,
    y1: 19.564,
    x2: 17.599,
    y2: 19.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__t",
    x1: 21.349,
    y1: 20.914,
    x2: 21.373,
    y2: 20.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__u",
    x1: 21.273,
    y1: 22.573,
    x2: 21.478,
    y2: 22.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__v",
    x1: 21.244,
    y1: 19.276,
    x2: 21.45,
    y2: 19.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__w",
    x1: 12.986,
    y1: 25.463,
    x2: 24.436,
    y2: 25.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__x",
    x1: 14.657,
    y1: 26.558,
    x2: 14.68,
    y2: 26.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__y",
    x1: 14.572,
    y1: 27.187,
    x2: 14.777,
    y2: 27.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__z",
    x1: 14.561,
    y1: 25.948,
    x2: 14.766,
    y2: 25.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__A",
    x1: 19.11,
    y1: 23.357,
    x2: 19.134,
    y2: 23.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__B",
    x1: 19.034,
    y1: 25.021,
    x2: 19.24,
    y2: 25.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__C",
    x1: 19.006,
    y1: 21.714,
    x2: 19.211,
    y2: 21.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__D",
    x1: 22.951,
    y1: 21.788,
    x2: 22.975,
    y2: 21.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__E",
    x1: 22.873,
    y1: 23.158,
    x2: 23.078,
    y2: 23.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__F",
    x1: 22.85,
    y1: 20.438,
    x2: 23.055,
    y2: 20.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__G",
    x1: 11.22,
    y1: 21.149,
    x2: 12.104,
    y2: 21.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__H",
    x1: 15.74,
    y1: 13.706,
    x2: 17.598,
    y2: 13.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__I",
    x1: 17.942,
    y1: 13.593,
    x2: 19.825,
    y2: 13.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__J",
    x1: 20.278,
    y1: 13.649,
    x2: 22.146,
    y2: 13.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__K",
    x1: 15.65,
    y1: 13.743,
    x2: 21.907,
    y2: 13.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__L",
    x1: 16.898,
    y1: 3.988,
    x2: 19.177,
    y2: 7.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__M",
    x1: 17.732,
    y1: 4.308,
    x2: 19.664,
    y2: 8.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__N",
    x1: 17.823,
    y1: 5.154,
    x2: 16.884,
    y2: 5.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__O",
    x1: 16.986,
    y1: 5.578,
    x2: 16.106,
    y2: 6.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__P",
    x1: 18.723,
    y1: 6.616,
    x2: 18.027,
    y2: 5.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ED7936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#CF5C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BC4A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__Q",
    x1: 18.249,
    y1: 5.244,
    x2: 17.076,
    y2: 5.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-header-icon_svg__R",
    x1: 16.617,
    y1: 9.406,
    x2: 18.056,
    y2: 9.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })))));
};
export { SvgCalendarHeaderIcon as ReactComponent };
export default __webpack_public_path__ + "9953a5499cf263d90a813088cba900b6.svg";